import { MutableRefObject, useRef } from 'react';
import useUpdateEffect from 'common/utils/hooks/useUpdateEffect';
import { isOverflownX } from 'common/utils/overflow';

const useHorizontalScroll = (ref: MutableRefObject<HTMLElement | null>) => {
  const isScrolling = useRef(false);
  const clientX = useRef(0);
  const scrollX = useRef(0);

  const onPointerDown = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (isOverflownX(ref.current)) {
      isScrolling.current = true;

      const element = ref.current ? ref.current : null;

      if (element) {
        clientX.current = e.clientX - element.offsetLeft;

        scrollX.current = element.scrollLeft;
      }
    }
  };

  const onPointerUp = () => {
    isScrolling.current = false;
  };

  const onPointerMove = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const element = ref.current ? ref.current : null;

    if (isScrolling.current && element) {
      const x = e.clientX - element.offsetLeft;
      const scroll = x - clientX.current;
      element.scrollLeft = scrollX.current - scroll;
    }
  };

  const onPointerLeave = () => {
    onPointerUp();
  };

  useUpdateEffect(() => {
    if (isScrolling.current) {
      ref.current?.classList.add('cursor-grabbing');
    } else {
      ref.current?.classList.remove('cursor-grabbing');
    }
  }, [isScrolling]);

  return {
    isScrolling,
    onPointerDown,
    onPointerUp,
    onPointerMove,
    onPointerLeave
  };
};
export default useHorizontalScroll;
